// import axios from "utils/axios";
import Config from 'config';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { addKrakenAssetPairs } from "store/actions";

const getData = async (u) => {

    // TODO PROD
    let url = 'https://'+Config.takyon_domain+'/AssetPairs';


  const response = await axios.get(
    url,
    {},
    {
      headers: {
        "Accept":	"*",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return response.data;
};

export default function useKrakenAssetPairs() {
  const dispatch = useDispatch();

  const fetchKrakenAssetPairs = () => {

    getData({}).then((data) => {
      dispatch(addKrakenAssetPairs(data));
    });
  };

  return {
    fetchKrakenAssetPairs,
  };
}
